var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefense = function SvgDefense(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1340,
    height: 1460,
    viewBox: "-52 0 1340 1460"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1153 531q-7 48-7 122.5t-2 123.5q-9 135-48 254.5t-77 171.5q-70 96-172.5 161T619 1460q-126-30-229.5-95T217 1203q-38-52-77.5-171.5T91 777q-2-34-2-116t-6-130Q58 333-52 150q181 42 362 0Q485 109 618 0q133 110 308 150 181 42 362 0-111 183-135 381"
  })));
};
export default SvgDefense;